import { useFormik } from 'formik';
import { useState } from 'react';
import { collection } from 'firebase/firestore';
import { useUser, useFirestore, useFirestoreCollectionData, useFunctions } from 'reactfire';
// material
import { Container, Stack, Typography, CircularProgress } from '@mui/material';
// components
import Page from '../components/Page';
import { ProductSort, ProductList, ProductFilterSidebar } from '../components/_dashboard/products';
//

// ----------------------------------------------------------------------

export default function EcommerceShop() {
  const { data: user } = useUser();
  const firestore = useFirestore();
  const path = `users/${user.uid}/collections`;
  const ref = collection(firestore, path);
  const { status, data } = useFirestoreCollectionData(ref);
  const [openFilter, setOpenFilter] = useState(false);

  const formik = useFormik({
    initialValues: {
      gender: '',
      category: '',
      colors: '',
      priceRange: '',
      rating: ''
    },
    onSubmit: () => {
      setOpenFilter(false);
    }
  });

  const { resetForm, handleSubmit } = formik;

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleResetFilter = () => {
    handleSubmit();
    resetForm();
  };

  return (
    <Page title="Dashboard: Products | Minimal-UI">
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Tracked Collections
        </Typography>

        <Stack
          direction="row"
          flexWrap="wrap-reverse"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mb: 5 }}
        >
          <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            <ProductSort />
          </Stack>
        </Stack>

        {status === 'success' && <ProductList products={data} />}
      </Container>
    </Page>
  );
}
